
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/dpa",
      function () {
        return require("private-next-pages/legal/dpa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/dpa"])
      });
    }
  